import { IMG_URL } from "configs";
import { motion } from "framer-motion";
import { animeTemplate, animeTransitions } from "./Anime";
import { useCatalog } from "catalog/Catalog.context";

export default function Image({
  src,
  alt,
  className,
  anime,
  transition = "pop",
  delay = 0,
  duration,
  ...props
}) {
  const { isResponsive } = useCatalog();
  let animation = {};

  if (anime) {
    if (typeof anime === "string") {
      animation = { ...animeTemplate[anime] };
    } else {
      animation = { ...animeTemplate[isResponsive ? anime.mobile : anime.default] };
    }
  }

  animation.transition = { ...animeTransitions[transition], delay };

  if (duration) {
    animation.transition.duration = duration;
  }

  return (
    <motion.img
      src={`${IMG_URL}/${src}`}
      alt={alt}
      className={className}
      {...animation}
      {...props}
    />
  );
}
